// extracted by mini-css-extract-plugin
export default {"buttons":"ReportCardWidget_buttons__VsCeP"};